import React from 'react';

import { useColors } from '../../hooks';
import { Button, ButtonProps } from '../button/button';

const SecondaryButton = (props: ButtonProps) => {
  const colors = useColors();

  return (
    <Button
      backgroundColor={colors.onPrimary}
      textStyle={{ color: colors.gray }}
      {...props}
    />
  );
};
export default SecondaryButton;
